import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';
/**
 * 自定义的表达式事件服务类
 * 功能：定义表达式内部的事件发布与监听接口
 */
@Injectable()
export class ExpressionEventService {
  // Observable string sources
  private windowClosed = new Subject<string>();
  // Observable string streams
  windowClosed$ = this.windowClosed.asObservable();
  // Service message commands
  closeWindow() {
    this.windowClosed.next();
  }
  //创建Observable源
  private _expressionsource: Subject<any> = new Subject<any>();
  //定义发布表达式实体方法
  setExpression(expressionentity: any): void {
    this._expressionsource.next(expressionentity);
  }
  //定义获得表达式实体方法
  getExpression(): Observable<any> {
    return this._expressionsource.asObservable();
  }
  //在光标处插入表达式事件发布与订阅
  private _insertexpression: Subject<any> = new Subject<any>();
  insertExpression(expression:string): void{
    this._insertexpression.next(expression);
  }
  currentExpression():Observable<any>{
    return this._insertexpression.asObservable();
  }
  
  private _clearexpression: Subject<any> = new Subject<any>();
  pushclearExpression(): void{
    this._clearexpression.next();
  }
  clearExpression():Observable<any>{
    return this._clearexpression.asObservable();
  }
  //函数选择焦点清除
  private _clearFuncSelect:Subject<any> = new Subject<any>();
  clearFuncSelect(): void{
    this._clearFuncSelect.next();
  }
  subClearFuncSelect():Observable<any>{
    return this._clearFuncSelect.asObservable();
  }
  //变量选择焦点清除
  private _clearVarSelect:Subject<any> = new Subject<any>();
  clearVarSelect(): void{
    this._clearVarSelect.next();
  }
  subClearVarSelect():Observable<any>{
    return this._clearVarSelect.asObservable();
  }
}